import { create } from '@wix/fedops-logger';
import { FEDOPS_APP_NAME } from '../constants';

const fedopsLogger = create(FEDOPS_APP_NAME);

let _appLoadedReported = false;

function reportAppLoaded() {
  if (!_appLoadedReported) {
    _appLoadedReported = true;
    if (process.env.NODE_ENV === 'production') {
      fedopsLogger.appLoaded();
    } else {
      console.log('%cFEDOPS', 'font-weight:bold', 'App Loaded');
    }
  }
}

export { reportAppLoaded };
